"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _nuiIntl = require("@concur/nui-intl");

var _reactRouter = require("react-router");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _has2 = _interopRequireDefault(require("lodash/has"));

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/terms.css") : void 0;

var _TermsPanel = _interopRequireDefault(require("./TermsPanel"));

var _analytics = require("../constants/analytics");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TandC = function TandC(_ref) {
  var terms = _ref.terms,
      userId = _ref.userId,
      toggleModal = _ref.toggleModal,
      toggleNeedAnAccountClicked = _ref.toggleNeedAnAccountClicked,
      updateTermsStatus = _ref.updateTermsStatus,
      connect = _ref.connect,
      postTerms = _ref.postTerms,
      listingId = _ref.listingId,
      v1ListingId = _ref.v1ListingId,
      flow = _ref.flow,
      _ref$partnerAppScopes = _ref.partnerAppScopes,
      partnerAppScopes = _ref$partnerAppScopes === void 0 ? [] : _ref$partnerAppScopes,
      clientOptInType = _ref.clientOptInType,
      listing = _ref.listing,
      router = _ref.router,
      formatter = _ref.formatter,
      trackButtonClick = _ref.trackButtonClick,
      trackLinkClick = _ref.trackLinkClick,
      companyUUID = _ref.companyUUID;
  var isTaCModalOpen = terms.isTaCModalOpen,
      content = terms.content,
      appcenterStatus = terms.appcenterStatus,
      sharedInfoStatus = terms.sharedInfoStatus,
      sharedInfo = terms.sharedInfo,
      loa = terms.loa,
      tAndCLinkClicked = terms.tAndCLinkClicked;
  var _listing$data = listing[(0, _has2.default)(listing, listingId) ? listingId : v1ListingId].data;
  _listing$data = _listing$data === void 0 ? {} : _listing$data;
  var _listing$data$core = _listing$data.core;
  _listing$data$core = _listing$data$core === void 0 ? {} : _listing$data$core;
  var listingName = _listing$data$core.listingName,
      _listing$data$localiz = _listing$data.localized;
  _listing$data$localiz = _listing$data$localiz === void 0 ? {} : _listing$data$localiz;
  var partnerPolicyURL = _listing$data$localiz.partnerPolicyURL,
      partnerTermsURL = _listing$data$localiz.partnerTermsURL;
  var style = {
    overlay: {
      zIndex: '100',
      position: 'fixed',
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
      position: 'initial',
      width: '600px',
      maxHeight: '80%',
      margin: '75px auto'
    }
  };
  var ADMIN = 'ADMIN';

  var handleClickTermsLearnMoreLink = function handleClickTermsLearnMoreLink(e) {
    trackLinkClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.termsAndConditions, _analytics.learnMoreSharedInfoLink],
      dimensions: {
        listingId: listingId,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
  };

  var createHTMLMarkup = function createHTMLMarkup(html) {
    return {
      __html: html
    };
  };

  var handleCheckboxUpdate = function handleCheckboxUpdate(e) {
    updateTermsStatus(e.target.id, e.target.checked);
  };

  var AppCenterTerms = _react.default.createElement(_TermsPanel.default, {
    checkboxId: "appcenterStatus",
    title: formatter.formattedMessage({
      id: 'TermsAppCenterTitle'
    }),
    description: formatter.formattedMessage({
      id: 'TermsAppCenterDescription'
    }),
    checked: appcenterStatus.currentlyAccepted,
    onChange: handleCheckboxUpdate,
    showCheckbox: !tAndCLinkClicked
  }, _react.default.createElement("div", {
    dangerouslySetInnerHTML: createHTMLMarkup((0, _find2.default)(content, {
      type: 'appcenter'
    }).content)
  }));

  var concurPrivacyPolicy = _react.default.createElement("a", {
    target: "_blank",
    href: "https://www.concur.com/en-us/processor-privacy-statement"
  }, formatter.formattedMessage({
    id: 'ProcessorPrivacyStatement'
  }));

  var linkToPartnerPolicy = partnerPolicyURL ? _react.default.createElement("a", {
    target: "_blank",
    href: partnerPolicyURL
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "PartnerPolicyURL"
  })) : _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "PartnerPolicyURL"
  });

  var sharedInfoTerms = _react.default.createElement(_TermsPanel.default, {
    checkboxId: "sharedInfoStatus",
    title: formatter.formattedMessage({
      id: 'TermsAccessAuthTitle'
    }),
    description: formatter.formattedMessage({
      id: 'TermsAccessAuthDescription'
    }),
    checked: sharedInfoStatus.currentlyAccepted,
    onChange: handleCheckboxUpdate,
    showCheckbox: !tAndCLinkClicked
  }, _react.default.createElement("p", null, clientOptInType !== ADMIN ? _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "TermsAccessAuthSubtitle"
  }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "TermsAccessAuthSubtitleEnterprise"
  }), _react.default.createElement("span", null, _react.default.createElement("a", {
    target: "_blank",
    href: "https://developer.concur.com/api-reference/authentication/app-center-learn-more.html",
    onClick: handleClickTermsLearnMoreLink
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "LearnMoreAboutServiceFieldExposed"
  })))), _react.default.createElement("ul", null, sharedInfo.map(function (el, i) {
    return _react.default.createElement("li", {
      className: "shared-bullet",
      key: i
    }, el);
  })), _react.default.createElement("p", null, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "ConcurValuesPrivacy",
    values: {
      concurPrivacyPolicy: concurPrivacyPolicy,
      linkToPartnerPolicy: linkToPartnerPolicy
    }
  })));

  var LOATerms = _react.default.createElement(_TermsPanel.default, {
    checkboxId: "loaStatus",
    showCheckbox: !tAndCLinkClicked,
    checked: loa && loa.status.currentlyAccepted,
    onChange: handleCheckboxUpdate,
    title: formatter.formattedMessage({
      id: 'AccessAuthorization'
    }),
    description: formatter.formattedMessage({
      id: 'AccessAuthorizationDescription'
    })
  }, _react.default.createElement("div", {
    dangerouslySetInnerHTML: createHTMLMarkup(loa && loa.content && loa.content.html)
  }));

  var isNUI = window.location.pathname.indexOf('nui') >= 0;
  var loaLink = "".concat(isNUI ? '/nui' : '', "/appcenter/terms/loa");
  var linkToPartnerTerms = partnerTermsURL ? _react.default.createElement("a", {
    target: "_blank",
    href: partnerTermsURL
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "PartnerTermsURL"
  })) : _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "PartnerTermsURL"
  });

  var linkToLoaTerms = _react.default.createElement("a", {
    target: "_blank",
    href: loaLink
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "AccessAuthorization"
  }));

  var getContent = function getContent() {
    return _react.default.createElement("div", null, _react.default.createElement("div", {
      className: "col-xs-12",
      style: {
        padding: '0px'
      }
    }, _react.default.createElement("h3", null, formatter.formattedMessage({
      id: 'TermsReview'
    })), _react.default.createElement("p", null, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: clientOptInType === ADMIN ? 'TermsByAcceptEnterprise' : 'TermsByAccept',
      values: {
        loaTermsURL: linkToLoaTerms,
        partnerTermsURL: linkToPartnerTerms
      }
    }))), _react.default.createElement("div", {
      className: "col-xs-12",
      style: {
        padding: '0px'
      }
    }, tAndCLinkClicked || !appcenterStatus.previouslyAccepted ? AppCenterTerms : null, tAndCLinkClicked || flow !== 'WEBFLOW' ? sharedInfoTerms : null, clientOptInType === ADMIN && (tAndCLinkClicked || !loa.status.previouslyAccepted) ? LOATerms : null));
  };

  var handleCancelClick = function handleCancelClick(e) {
    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.termsAndConditions, _analytics.button.cancel],
      dimensions: {
        listingId: listingId,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    e.preventDefault();
    toggleNeedAnAccountClicked(false);
    updateTermsStatus('appcenterStatus', false);
    updateTermsStatus('sharedInfoStatus', false);
    updateTermsStatus('loaStatus', false);
    return toggleModal(false);
  };

  var renderButtons = function renderButtons() {
    // I wish these could be in Promise.all()
    // but connect has to be REALLY close to the user clicking
    // or else chrome blocks the popup
    var handleActpBtnClk = function handleActpBtnClk() {
      trackButtonClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.termsAndConditions, _analytics.button.accept],
        dimensions: {
          listingId: listingId,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      postTerms(userId, 'appcenter');

      if (clientOptInType === ADMIN) {
        postTerms(userId, 'loa');
      }

      toggleModal();
      updateTermsStatus('sharedInfoStatus', false);
      return connect(listingId, v1ListingId, userId);
    }; // Button is disabled unless appcenter terms are previously or currently
    // accepted and shared info is currently accepted


    var renderAcceptBtn = function renderAcceptBtn() {
      var disabledBtn = _react.default.createElement("button", {
        className: "btn btn-default btn-lg",
        disabled: true
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "IAgree"
      })); // TODO: do we even need to check previous if we set current = previous on fetch?


      if (!appcenterStatus.currentlyAccepted && !appcenterStatus.previouslyAccepted) {
        return disabledBtn;
      }

      if (!sharedInfoStatus.currentlyAccepted && flow !== 'WEBFLOW') {
        return disabledBtn;
      }

      if (!loa.status.currentlyAccepted && !loa.status.previouslyAccepted && clientOptInType === ADMIN) {
        return disabledBtn;
      }

      return _react.default.createElement("button", {
        className: "btn btn-default btn-lg",
        onClick: handleActpBtnClk
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "IAgree"
      }));
    };

    return _react.default.createElement("div", {
      className: "tandc-buttons"
    }, _react.default.createElement("a", {
      href: "#",
      onClick: handleCancelClick
    }, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "Cancel"
    })), renderAcceptBtn());
  };

  _reactModal.default.setAppElement('#root');

  return _react.default.createElement("div", {
    className: "modal-container"
  }, _react.default.createElement(_reactModal.default, {
    style: style,
    isOpen: isTaCModalOpen,
    onRequestClose: toggleModal.bind(null, false),
    contentLabel: "Terms for connecting to listing modal"
  }, _react.default.createElement("div", {
    className: "row inside-modal"
  }, _react.default.createElement("div", {
    className: "col-xs-12"
  }, _react.default.createElement("span", {
    className: "close-tandc-modal pull-right",
    onClick: handleCancelClick
  }, "\xD7"), _react.default.createElement("h2", null, formatter.formattedMessage({
    id: 'TermsTitle'
  })), _react.default.createElement("hr", null), getContent(), _react.default.createElement("div", null, _react.default.createElement("div", {
    className: "col-xs-12 tc-hr no-padding"
  }, !tAndCLinkClicked && _react.default.createElement("hr", null)), _react.default.createElement("div", {
    className: "col-xs-12 no-padding"
  }, !tAndCLinkClicked && renderButtons(appcenterStatus, sharedInfoStatus)))))));
};

TandC.propTypes = {
  terms: _propTypes.default.shape({
    isTaCModalOpen: _propTypes.default.bool,
    appcenterTerms: _propTypes.default.string,
    ereceiptStatus: _propTypes.default.object,
    appcenterStatus: _propTypes.default.object,
    sharedInfoStatus: _propTypes.default.object,
    sharedInfo: _propTypes.default.array,
    tAndCLinkClicked: _propTypes.default.bool
  }).isRequired,
  flow: _propTypes.default.string,
  clientOptInType: _propTypes.default.string,
  listing: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  router: _propTypes.default.any,
  // eslint-disable-line react/forbid-prop-types
  listingId: _propTypes.default.string,
  v1ListingId: _propTypes.default.string,
  userId: _propTypes.default.string,
  toggleModal: _propTypes.default.func.isRequired,
  toggleNeedAnAccountClicked: _propTypes.default.func,
  updateTermsStatus: _propTypes.default.func.isRequired,
  connect: _propTypes.default.func.isRequired,
  postTerms: _propTypes.default.func.isRequired,
  partnerAppScopes: _propTypes.default.array,
  // eslint-disable-line react/forbid-prop-types
  formatter: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  trackButtonClick: _propTypes.default.func,
  trackLinkClick: _propTypes.default.func,
  companyUUID: _propTypes.default.string
};

var _default = (0, _reactRouter.withRouter)((0, _nuiIntl.withFormatter)(TandC));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/terms/TermsAndConditions.js
// module id = 267
// module chunks = 0